import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "red"
}
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = {
  href: "/news",
  class: "text-sm text-blue-700 hover:text-blue-900 mb-6 inline-block"
}
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_5 = { class: "text-2xl font-bold text-gray-900 mb-6" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3"
}
const _hoisted_7 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_8 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_9 = { class: "flex items-start gap-4" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_13 = { class: "text-xs text-gray-500 mb-2" }
const _hoisted_14 = {
  class: "relative rounded-lg border border-gray-200 overflow-hidden select-none",
  style: {"max-width":"500px"},
  ref: "cropContainer"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "text-xs text-gray-400 mt-3 mb-1" }
const _hoisted_17 = {
  class: "rounded-lg border border-gray-200 overflow-hidden",
  style: {"max-width":"500px"}
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_20 = { class: "flex items-center gap-3 pt-4" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  href: "/news",
  class: "px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "news"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, "← " + _toDisplayString($setup.t('news.back_to_list')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString($props.editing ? $setup.t('news.edit_news') : $setup.t('news.new_news')), 1 /* TEXT */),
        ($setup.formErrors.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formErrors, (error) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: error,
                  class: "text-sm text-red-700"
                }, _toDisplayString(error), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.flash)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
            }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("form", {
          onSubmit: _withModifiers($setup.submitForm, ["prevent"]),
          class: "space-y-6"
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_7, _toDisplayString($setup.t('news.name')), 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form.title) = $event)),
              type: "text",
              required: "",
              class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.form.title]
            ])
          ]),
          _createCommentVNode(" Cover image "),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_8, _toDisplayString($setup.t('news.cover_image')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", {
                  ref: "coverInput",
                  type: "file",
                  accept: "image/*",
                  class: "hidden",
                  onChange: $setup.uploadCover
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.$refs.coverInput.click())),
                  disabled: $setup.coverUploading,
                  class: "px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
                }, _toDisplayString($setup.coverUploading ? '...' : ($setup.form.cover_image_url ? $setup.t('news.change_cover') : $setup.t('news.upload_cover'))), 9 /* TEXT, PROPS */, _hoisted_11),
                ($setup.form.cover_image_url)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = $event => {$setup.form.cover_image_url = ''; $setup.form.cover_position = ''}),
                      class: "px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
                    }, _toDisplayString($setup.t('news.remove_cover')), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.bodyHasImage && !$setup.form.cover_image_url)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      onClick: $setup.useBodyImage,
                      class: "text-xs text-blue-700 hover:underline text-left"
                    }, _toDisplayString($setup.t('news.use_body_image')), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" Cover crop selector "),
            ($setup.form.cover_image_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString($setup.t('news.cover_crop_hint')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("img", {
                      src: $setup.form.cover_image_url,
                      class: "w-full",
                      ref: "coverPreview"
                    }, null, 8 /* PROPS */, _hoisted_15),
                    _createCommentVNode(" Dark overlays "),
                    _createElementVNode("div", {
                      class: "absolute top-0 left-0 right-0 bg-black/50 pointer-events-none",
                      style: _normalizeStyle(`height: ${$setup.cropTop}%`)
                    }, null, 4 /* STYLE */),
                    _createElementVNode("div", {
                      class: "absolute bottom-0 left-0 right-0 bg-black/50 pointer-events-none",
                      style: _normalizeStyle(`height: ${100 - $setup.cropBottom}%`)
                    }, null, 4 /* STYLE */),
                    _createElementVNode("div", {
                      class: "absolute left-0 bg-black/50 pointer-events-none",
                      style: _normalizeStyle(`top: ${$setup.cropTop}%; height: ${$setup.cropBottom - $setup.cropTop}%; width: ${$setup.cropLeft}%`)
                    }, null, 4 /* STYLE */),
                    _createElementVNode("div", {
                      class: "absolute right-0 bg-black/50 pointer-events-none",
                      style: _normalizeStyle(`top: ${$setup.cropTop}%; height: ${$setup.cropBottom - $setup.cropTop}%; width: ${100 - $setup.cropRight}%`)
                    }, null, 4 /* STYLE */),
                    _createCommentVNode(" Top handle "),
                    _createElementVNode("div", {
                      class: "absolute left-0 right-0 h-1 bg-blue-500 cursor-ns-resize z-10",
                      style: _normalizeStyle(`top: ${$setup.cropTop}%`),
                      onMousedown: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.startDrag('top', $event)), ["prevent"])),
                      onTouchstart: _cache[4] || (_cache[4] = _withModifiers($event => ($setup.startDrag('top', $event)), ["prevent"]))
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("div", { class: "absolute left-1/2 -translate-x-1/2 -top-2 w-6 h-4 bg-blue-500 rounded-t text-white text-[8px] text-center leading-4 shadow" }, "▲", -1 /* CACHED */)
                    ]))], 36 /* STYLE, NEED_HYDRATION */),
                    _createCommentVNode(" Bottom handle "),
                    _createElementVNode("div", {
                      class: "absolute left-0 right-0 h-1 bg-blue-500 cursor-ns-resize z-10",
                      style: _normalizeStyle(`top: ${$setup.cropBottom}%`),
                      onMousedown: _cache[5] || (_cache[5] = _withModifiers($event => ($setup.startDrag('bottom', $event)), ["prevent"])),
                      onTouchstart: _cache[6] || (_cache[6] = _withModifiers($event => ($setup.startDrag('bottom', $event)), ["prevent"]))
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("div", { class: "absolute left-1/2 -translate-x-1/2 -bottom-2 w-6 h-4 bg-blue-500 rounded-b text-white text-[8px] text-center leading-4 shadow" }, "▼", -1 /* CACHED */)
                    ]))], 36 /* STYLE, NEED_HYDRATION */),
                    _createCommentVNode(" Left handle "),
                    _createElementVNode("div", {
                      class: "absolute top-0 bottom-0 w-1 bg-blue-500 cursor-ew-resize z-10",
                      style: _normalizeStyle(`left: ${$setup.cropLeft}%`),
                      onMousedown: _cache[7] || (_cache[7] = _withModifiers($event => ($setup.startDrag('left', $event)), ["prevent"])),
                      onTouchstart: _cache[8] || (_cache[8] = _withModifiers($event => ($setup.startDrag('left', $event)), ["prevent"]))
                    }, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("div", { class: "absolute top-1/2 -translate-y-1/2 -left-2 w-4 h-6 bg-blue-500 rounded-l text-white text-[8px] text-center leading-6 shadow" }, "◀", -1 /* CACHED */)
                    ]))], 36 /* STYLE, NEED_HYDRATION */),
                    _createCommentVNode(" Right handle "),
                    _createElementVNode("div", {
                      class: "absolute top-0 bottom-0 w-1 bg-blue-500 cursor-ew-resize z-10",
                      style: _normalizeStyle(`left: ${$setup.cropRight}%`),
                      onMousedown: _cache[9] || (_cache[9] = _withModifiers($event => ($setup.startDrag('right', $event)), ["prevent"])),
                      onTouchstart: _cache[10] || (_cache[10] = _withModifiers($event => ($setup.startDrag('right', $event)), ["prevent"]))
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("div", { class: "absolute top-1/2 -translate-y-1/2 -right-2 w-4 h-6 bg-blue-500 rounded-r text-white text-[8px] text-center leading-6 shadow" }, "▶", -1 /* CACHED */)
                    ]))], 36 /* STYLE, NEED_HYDRATION */)
                  ], 512 /* NEED_PATCH */),
                  _createCommentVNode(" Preview "),
                  _createElementVNode("p", _hoisted_16, _toDisplayString($setup.t('news.cover_crop_preview')) + ":", 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: $setup.croppedUrl,
                      class: "w-full"
                    }, null, 8 /* PROPS */, _hoisted_18)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_19, _toDisplayString($setup.t('news.body')), 1 /* TEXT */),
            _createVNode($setup["RichEditor"], {
              modelValue: $setup.form.body,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.form.body) = $event)),
              placeholder: $setup.t('news.body_placeholder'),
              "csrf-token": $props.csrfToken
            }, null, 8 /* PROPS */, ["modelValue", "placeholder", "csrf-token"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "submit",
              disabled: $setup.submitting,
              class: "px-6 py-2.5 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
            }, _toDisplayString($setup.submitting ? '...' : ($props.editing ? $setup.t('news.save') : $setup.t('news.create'))), 9 /* TEXT, PROPS */, _hoisted_21),
            _createElementVNode("a", _hoisted_22, _toDisplayString($setup.t('news.cancel')), 1 /* TEXT */)
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ])
  ]))
}